import { css } from '@emotion/react'

export const paperMainClass = css`
  outline: none !important;
  position: relative;
  margin: auto;
  max-width: 95vw;
  max-height: 95svh;
`
